import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Alert } from 'reactstrap';
import LoadingScreen from 'react-loading-screen';
import logo from 'assets/img/logo/logo_aig_login-2.png';
import Page from '../../../../components/Page';
import Steps from '../../../../components/Generales/Steps';
import Formulario from '../../../../components/Generales/Formulario';
import jsonMotoP1 from '../../json/formulario-cotizador-motos-p1.json';
import { guardarCotizacionMotoPaso1, obtenerCotizacionMoto } from '../../redux/aMotos';
import { urlConsultarPlaca, ambienteAplicacion } from '../../../../constants/urls';
import { httpClient } from '../../../../api/httpClient';

const CotizadorMoto = ({
    history,
    location,
    guardarCotizacionMotoPaso1,
    obtenerCotizacionMoto,
    estadoMotos,
    datosUsuarios,
    datosSucursales,
    sucursales
}) => {
    const [loading, setLoading] = useState(false);
    const [values, setValues] = useState({});
    const [valuesConTitulo, setValuesConTitulo] = useState({});
    const [valuesInicial, setValuesInicial] = useState({});
    const [errorMensaje, setErrorMensaje] = useState(null);
    const [datosConsultaPlaca, setDatosConsultaPlaca] = useState(null);
    const [datosAseguradoGuardados, setDatosAseguradoGuardados] = useState(null);
    const [datosConductorGuardados, setDatosConductorGuardados] = useState(null);
    
    const placaConsultadaRef = useRef('');

    const listaOpciones = [
        { id: 0, label: 'Cotización', value: 'cotizacion' },
        { id: 1, label: 'Resumen', value: 'resumen' },
        { id: 2, label: 'Confirmación', value: 'confirmacion' },
        { id: 3, label: 'Forma de Pago', value: 'forma-pago' },
        { id: 4, label: 'Formulario de Vinculación', value: 'formulario-vinculacion' },
        { id: 5, label: 'Emisión', value: 'emision' }
    ];

    // Leer idCarrito de query params si viene para modificar
    var queryParams = new URLSearchParams(location ? location.search : '');
    var idCarrito = queryParams.get('idCarrito') || queryParams.get('id');

    useEffect(() => {
        var cargarDatosGuardados = async () => {
            if (idCarrito) {
                setLoading(true);
                var res = await obtenerCotizacionMoto(idCarrito);
                setLoading(false);
                if (res && res.exito && res.data) {
                    var v = res.data.datosVehiculo || {};
                    var codProv = v.codProvincia || v.provincia || '';
                    var nomProv = v.provinciaNombre || (typeof v.provincia === 'string' ? v.provincia : (v.provincia && v.provincia.label) || '');
                    
                    var codCiudad = v.codCiudad || v.ciudad || '';
                    var nomCiudad = v.ciudadNombre || (typeof v.ciudad === 'string' ? v.ciudad : (v.ciudad && v.ciudad.label) || '');

                    var codSuc = v.sucursal || '';
                    var nomSuc = v.sucursalNombre || (typeof v.sucursal === 'string' ? v.sucursal : (v.sucursal && v.sucursal.label) || '');

                    var codMarca = v.marca || '';
                    var nomMarca = v.marcaNombre || (typeof v.marca === 'string' ? v.marca : (v.marca && v.marca.label) || '');

                    var codModelo = v.modelo || '';
                    var nomModelo = v.modeloNombre || (typeof v.modelo === 'string' ? v.modelo : (v.modelo && v.modelo.label) || '');

                    var formValues = {
                        placa: v.placa || '',
                        provincia: codProv ? { value: codProv, label: nomProv || codProv } : (nomProv ? { value: nomProv, label: nomProv } : null),
                        ciudad: codCiudad ? { value: codCiudad, label: nomCiudad || codCiudad } : (nomCiudad ? { value: nomCiudad, label: nomCiudad } : null),
                        sucursal: codSuc ? { value: codSuc, label: nomSuc || codSuc } : (nomSuc ? { value: nomSuc, label: nomSuc } : null),
                        marca: codMarca ? { value: codMarca, label: nomMarca || codMarca } : (nomMarca ? { value: nomMarca, label: nomMarca } : null),
                        modelo: codModelo ? { value: codModelo, label: nomModelo || codModelo } : (nomModelo ? { value: nomModelo, label: nomModelo } : null),
                        tipo: v.tipo || 'MOTO',
                        anio: v.anio || '',
                        valorAsegurado: v.valorAsegurado || ''
                    };
                    setValues(formValues);
                    setValuesInicial(formValues);

                    if (v.placa) {
                        placaConsultadaRef.current = v.placa.trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
                    }

                    if (res.data.datosAsegurado || (res.data.carrito && res.data.carrito.datosAsegurado)) {
                        setDatosAseguradoGuardados(res.data.datosAsegurado || res.data.carrito.datosAsegurado);
                    }
                    if (res.data.datosConductor || (res.data.carrito && res.data.carrito.datosConductor)) {
                        setDatosConductorGuardados(res.data.datosConductor || res.data.carrito.datosConductor);
                    }
                }
            }
        };
        cargarDatosGuardados();
    }, [idCarrito]);

    const isGlobalLoading = loading || (estadoMotos && estadoMotos.isLoading);

    const consultarPlacaWS = async (placaRaw) => {
        if (!placaRaw) return;
        var cleanPlaca = String(placaRaw).trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
        if (cleanPlaca.length < 5) return;
        if (cleanPlaca === placaConsultadaRef.current) return;

        setLoading(true);
        setErrorMensaje(null);

        try {
            var url = urlConsultarPlaca + encodeURIComponent(cleanPlaca);
            var res = await httpClient.get(url);
            
            if (res) {
                placaConsultadaRef.current = cleanPlaca;

                // Mensaje de restricción (no mostrar si la clase del vehículo es MOTOCICLETA)
                var esClaseMotocicleta = res.clase && String(res.clase).trim().toUpperCase() === 'MOTOCICLETA';
                if (res.mostrarMensajeRestriccion && res.MensajeRestriccion && !esClaseMotocicleta) {
                    setErrorMensaje(res.MensajeRestriccion);
                } else {
                    setErrorMensaje(null);
                }

                // Actualizar marca y año en el formulario
                setValues(function(prevValues) {
                    var upd = Object.assign({}, prevValues);
                    upd.placa = cleanPlaca;

                    if (res.marCodigoCore || res.marca) {
                        var marVal = res.marCodigoCore ? String(res.marCodigoCore) : res.marca;
                        var marLabel = res.marca || marVal;
                        var prevMarcaVal = upd.marca && typeof upd.marca === 'object' ? upd.marca.value : upd.marca;
                        if (String(prevMarcaVal || '') !== String(marVal || '')) {
                            upd.modelo = null;
                        }
                        upd.marca = { value: marVal, label: marLabel };
                    }

                    if (res.anio) {
                        upd.anio = String(res.anio);
                    }

                    return upd;
                });

                // Guardar datos técnicos y de propietario para la emisión
                var infoCons = {
                    placa: cleanPlaca,
                    motor: res.motor || '',
                    chasis: res.chasis || '',
                    cedula_propietario: res.cedula_propietario || '',
                    nombre_propietario: res.nombre_propietario || '',
                    fecha_nacimiento_propietario: res.fecha_nacimiento_propietario || '',
                    estado_civil_propietario: res.estado_civil_propietario || '',
                    codigo_estado_civil_propietario: res.codigo_estado_civil_propietario || '',
                    genero_propietario: res.genero_propietario || '',
                    codigo_genero_propietario: res.codigo_genero_propietario || ''
                };
                setDatosConsultaPlaca(infoCons);
            }
        } catch (err) {
            console.error('Error al consultar vehículo:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleFormChange = (key, newValues) => {
        if (key === 'marca') {
            newValues.modelo = null;
        }
        setValues(newValues);

        if (key === 'placa' && newValues.placa) {
            var clean = String(newValues.placa).trim().toUpperCase().replace(/[^A-Z0-9]/g, '');
            if (clean.length >= 6) {
                consultarPlacaWS(clean);
            }
        }
    };

    const handleFieldBlur = (fieldId, val) => {
        if (fieldId === 'placa') {
            consultarPlacaWS(val || values.placa);
        }
    };

    const handleSubmitPaso1 = async (formValues, tieneErrores, errores, valuesTitulo) => {
        if (tieneErrores) {
            return;
        }

        setLoading(true);
        setErrorMensaje(null);

        var provVal = formValues.provincia && formValues.provincia.value ? formValues.provincia.value : (typeof formValues.provincia === 'string' ? formValues.provincia : null);
        var provNom = formValues.provincia && formValues.provincia.label ? formValues.provincia.label : (typeof formValues.provincia === 'string' ? formValues.provincia : null);
        var provCore = (formValues.provincia && (formValues.provincia.provCodigoCore !== undefined ? formValues.provincia.provCodigoCore : formValues.provincia.prov_codigo_core)) || provVal;

        var ciudadVal = formValues.ciudad && formValues.ciudad.value ? formValues.ciudad.value : (typeof formValues.ciudad === 'string' ? formValues.ciudad : null);
        var ciudadNom = formValues.ciudad && formValues.ciudad.label ? formValues.ciudad.label : (typeof formValues.ciudad === 'string' ? formValues.ciudad : null);

        var sucVal = formValues.sucursal && formValues.sucursal.value ? formValues.sucursal.value : (typeof formValues.sucursal === 'string' ? formValues.sucursal : null);
        var sucNom = formValues.sucursal && formValues.sucursal.label ? formValues.sucursal.label : (typeof formValues.sucursal === 'string' ? formValues.sucursal : null);

        var marcaVal = formValues.marca && formValues.marca.value ? formValues.marca.value : (typeof formValues.marca === 'string' ? formValues.marca : '');
        var marcaNom = formValues.marca && formValues.marca.label ? formValues.marca.label : (typeof formValues.marca === 'string' ? formValues.marca : '');
        var modeloVal = formValues.modelo && formValues.modelo.value ? formValues.modelo.value : (typeof formValues.modelo === 'string' ? formValues.modelo : '');
        var modeloNom = formValues.modelo && formValues.modelo.label ? formValues.modelo.label : (typeof formValues.modelo === 'string' ? formValues.modelo : '');

        if (!marcaVal) {
            setErrorMensaje('Debe seleccionar una marca de vehículo.');
            setLoading(false);
            return;
        }

        if (!modeloVal) {
            setErrorMensaje('Debe seleccionar un modelo de vehículo.');
            setLoading(false);
            return;
        }

        var infoP = datosConsultaPlaca || {};

        // Formatear Fecha de Nacimiento
        var fechaNacFormateada = infoP.fecha_nacimiento_propietario || '';
        if (fechaNacFormateada.indexOf('/') !== -1) {
            var parts = fechaNacFormateada.split('/');
            if (parts.length === 3) {
                fechaNacFormateada = parts[2] + '-' + (parts[1].length === 1 ? '0' + parts[1] : parts[1]) + '-' + (parts[0].length === 1 ? '0' + parts[0] : parts[0]);
            }
        }

        // Formatear Género
        var genVal = (infoP.genero_propietario || '').toUpperCase();
        var genObj = null;
        if (genVal) {
            var esMas = (genVal.indexOf('M') === 0 || genVal === '1');
            genObj = { value: esMas ? '1' : '2', label: esMas ? 'Masculino' : 'Femenino' };
        }

        // Formatear Estado Civil
        var ecVal = (infoP.estado_civil_propietario || '').toUpperCase();
        var ecObj = null;
        if (ecVal) {
            var ecCod = '1';
            var matchLabel = 'Soltero(a)';
            if (ecVal.indexOf('CASAD') !== -1 || ecVal === '2') {
                ecCod = '2';
                matchLabel = 'Casado(a)';
            } else if (ecVal.indexOf('DIVOR') !== -1 || ecVal === '4') {
                ecCod = '4';
                matchLabel = 'Divorciado(a)';
            } else if (ecVal.indexOf('UNION') !== -1 || ecVal.indexOf('LIBRE') !== -1 || ecVal === '3') {
                ecCod = '3';
                matchLabel = 'Unión Libre';
            } else if (ecVal.indexOf('VIUD') !== -1 || ecVal === '5') {
                ecCod = '5';
                matchLabel = 'Viudo(a)';
            } else if (ecVal.indexOf('SOLT') !== -1 || ecVal === '1') {
                ecCod = '1';
                matchLabel = 'Soltero(a)';
            }
            ecObj = { value: ecCod, label: matchLabel };
        }

        var datosAseguradoObj = {
            tipoDocumento: { value: '1', label: 'Cédula de Identidad' },
            identificacion: infoP.cedula_propietario || '',
            nombres: infoP.nombre_propietario || '',
            fechaNacimiento: fechaNacFormateada,
            genero: genObj,
            estadoCivil: ecObj
        };

        var finalSucCod = sucVal || (datosSucursales && datosSucursales.sucursalSelecionadaAsesor) || "";
        var finalSucNom = sucNom || "";
        if (!finalSucNom && finalSucCod && Array.isArray(sucursales)) {
            var foundSuc = sucursales.find(function(s) { return s.sucCodigoCore == finalSucCod; });
            if (foundSuc) {
                finalSucNom = foundSuc.sucNombre;
            }
        }

        var arrayDatosAsesorObj = {
            nombre: `${(datosUsuarios && datosUsuarios.nombres) || ''} ${(datosUsuarios && datosUsuarios.apellidos) || ''}`.trim(),
            codigoCore: (datosUsuarios && datosUsuarios.cliCodigoCore) || "",
            sucursalSeleccionada: finalSucCod,
            sucursalSeleccionadaNombre: finalSucNom,
            ambiente: ambienteAplicacion,
            emailAsesor: (datosUsuarios && datosUsuarios.correo) || "",
            brokerRUC: (datosUsuarios && datosUsuarios.brokerRUC) || "",
            brokerNombre: (datosUsuarios && datosUsuarios.brokerNombre) || "",
            brokerCodigo: (datosUsuarios && datosUsuarios.brokerCodigo) || ""
        };

        var idUsuarioVal = (datosUsuarios && datosUsuarios.cliCodigoCore) ? String(datosUsuarios.cliCodigoCore) : "";

        var datosAseguradoFinal = Object.assign({}, datosAseguradoGuardados || datosAseguradoObj, {
            ciudad: ciudadNom || '',
            codCiudad: ciudadVal || '',
            provincia: provNom || '',
            codProvincia: provCore || ''
        });

        var datosConductorFinal = Object.assign({}, datosConductorGuardados || datosAseguradoObj, {
            ciudad: ciudadNom || '',
            codCiudad: ciudadVal || '',
            provincia: provNom || '',
            codProvincia: provCore || ''
        });

        var payload = {
            idCarrito: idCarrito || null,
            idUsuario: idUsuarioVal,
            arrayDatosAsesor: arrayDatosAsesorObj,
            datosVehiculo: {
                placa: formValues.placa ? formValues.placa.trim().toUpperCase() : '',
                codProvincia: provCore,
                provincia: provVal,
                provinciaNombre: provNom,
                codCiudad: ciudadVal,
                ciudad: ciudadVal,
                ciudadNombre: ciudadNom,
                sucursal: sucVal,
                sucursalNombre: sucNom,
                marca: marcaVal,
                marcaNombre: marcaNom,
                modelo: modeloVal,
                modeloNombre: modeloNom,
                tipo: formValues.tipo || 'MOTO',
                anio: formValues.anio ? parseInt(formValues.anio, 10) : null,
                valorAsegurado: formValues.valorAsegurado ? parseFloat(formValues.valorAsegurado) : null,
                motor: infoP.motor || '',
                chasis: infoP.chasis || ''
            },
            datosAsegurado: datosAseguradoFinal,
            datosConductor: datosConductorFinal
        };

        var result = await guardarCotizacionMotoPaso1(payload);
        setLoading(false);

        if (result && result.exito) {
            var targetId = result.data.idCarrito || (result.data.carrito && result.data.carrito._id) || idCarrito;

            // Guardar backup en localStorage por idCarrito
            if (targetId) {
                try {
                    localStorage.setItem('motos_datos_consulta_' + targetId, JSON.stringify({
                        datosConsulta: infoP,
                        datosAsegurado: datosAseguradoFinal,
                        datosConductor: datosConductorFinal
                    }));
                } catch (e) {
                    console.error('Error guardando en localStorage:', e);
                }
            }

            if (history) {
                history.push({
                    pathname: '/motos/emision',
                    search: '?idCarrito=' + targetId
                });
            }
        } else {
            var msg = result && result.error ? result.error : 'Ocurrió un error al guardar la cotización.';
            setErrorMensaje(msg);
        }
    };

    return (
        <LoadingScreen
            loading={isGlobalLoading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Procesando cotización de moto..."
        >
            <div className="cr-content container-fluid">
                <div className="container-body-spaces">
                    <Page
                        title="Cotización de Motos"
                        breadcrumbs={[{ name: "Cotización de Motos", active: true }]}
                    >
                        <Row>
                            <Col lg={8} md={12} sm={12} xs={12}>
                                <Steps 
                                    tipo={'parametrico'} 
                                    listaOpciones={listaOpciones} 
                                    paso={'cotizacion'} 
                                />
                            </Col>
                        </Row>

                        {errorMensaje && (
                            <Row>
                                <Col lg={8} md={12} sm={12} xs={12}>
                                    <Alert color="danger">
                                        {errorMensaje}
                                    </Alert>
                                </Col>
                            </Row>
                        )}

                        <Formulario
                            formularioLocal={jsonMotoP1}
                            anchoPagina={8}
                            setLoading={setLoading}
                            values={values}
                            valuesConTitulo={valuesConTitulo}
                            setValuesConTitulo={setValuesConTitulo}
                            setValuesInicial={setValuesInicial}
                            onChange={handleFormChange}
                            onBlur={handleFieldBlur}
                            onSubmit={handleSubmitPaso1}
                        />
                    </Page>
                </div>
            </div>
        </LoadingScreen>
    );
};

const mapStateToProps = (state) => ({
    estadoMotos: state.dataMotos,
    datosUsuarios: state.datosUsuarios ? state.datosUsuarios.dataUsuario : {},
    datosSucursales: state.datosSucursales || {},
    sucursales: state.datosSucursales ? state.datosSucursales.DataSucursales : []
});

const mapDispatchToProps = {
    guardarCotizacionMotoPaso1,
    obtenerCotizacionMoto
};

export default connect(mapStateToProps, mapDispatchToProps)(CotizadorMoto);
